import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import APIS from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalBody,
  Button,
  CardTitle,
  Form,
  Label,
  ModalHeader,
  Input,
  Progress,
} from "reactstrap"
import { withRouter } from "react-router"
//i18n
import { withTranslation } from "react-i18next"
import Select from "react-select"
import API from "../../api"
import { Slide, toast, ToastContainer } from "react-toastify"
import FileDownload from "js-file-download"

const DataTableImportListeEtudiantOrientation = props => {
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const lng = localStorage.getItem("I18N_LANGUAGE")
  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState([])
  const [departement, setDepartement] = useState([])
  const [selectDepartement, setSelectDepartement] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [add, setAdd] = useState(0)
  const [excel, setExcel] = useState(0);
  const [delet, setDelet] = useState(0);
  const [id, setId] = useState("")
  const [modal, setModal] = useState(false)
  const [cloture, setCloture] = useState(0);
  const [cycle, setCycle] = useState([])
  const [selectCycle, setSelectCycle] = useState("")
  const [niveau, setNiveau] = useState([])
  const [selectNiveau, setSelectNiveau] = useState("")
  const [file, setFile] = useState(null)
  const [uploadPercent, setUploadPercent] = useState(0)
  const { SearchBar } = Search

  useEffect(async () => {
    setLoading(true)
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Liste d'orientation")
    );
    setAdd(typeArticleSubMenu.sous_menu[0].add)
    setDelet(typeArticleSubMenu.sous_menu[0].delete)
    setExcel(typeArticleSubMenu.sous_menu[0].exel)
    const res = await API.post("admissions/list", {
      specialite_id: 0,
      niveau_id: 0,
      session_id: 0,
      annee_id,
    }).then(res => {
      setOrders(res.data.data)
    })
    const resDepartement = await API.get("departement/select").then(
      resDepartement => {
        setDepartement(resDepartement.data.Departement)
        setSelectDepartement("")
      }
    )

    const resC = await API.get("cycle/select").then(resC => {
      setCycle(resC.data.Cycle)
    })

  }, [])

  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: props.t("Suivant"),
    prePageText: props.t("Précedent"),
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>Aucun information à afficher</h6>
  )
  const Columns = () => [
    {
      dataField: "cin",
      text: "CIN",
      sort: true,
      style: {
        textAlign: "center",
      },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "name",
      text: "Nom et prénom",
      sort: true,
      style: {
        textAlign: "center",
      },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite",
      text: "Spécialité",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },

    {
      dataField: "niveau",
      text: "Niveau",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "session",
      text: "Session",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
  ]
  const toggle = id => {
    if (selectCycle === "") {
      toast.error("⛔ Veuillez choisir un cycle", {
        containerId: "A",
      })
    } else if (selectNiveau === "") {
      toast.error("⛔ Veuillez choisir un niveau", {
        containerId: "A",
      })
    } else if (selectDepartement === "") {
      toast.error("⛔ Veuillez choisir une département", {
        containerId: "A",
      })
    } else if (selectSpecialite !== "") {
      setModal(!modal)
      setUploadPercent(0)
    } else {
      toast.error("⛔ Veuillez choisir une spécialité", {
        containerId: "A",
      })
    }
  }
  const getNiveau = async event => {
    var cycle_id = event.value
    setSelectCycle(event)
    setSelectNiveau("")
    setSelectSpecialite("")
    if (cycle_id == 1) {
      const res = await API.get("niveau/select").then(res => {
        setNiveau(res.data.Niveau)
      })
    } else {
      const res = await API.get("niveau/select_mastere").then(res => {
        setNiveau(res.data.Niveau)
      })
    }
  }

  const getSpec = async event => {
    var departement_id = event.value
    setSelectSpecialite("")
    setSelectDepartement(event)
    const res = await API.post("specialite/select_by_departement_cycle", {
      departement_id: departement_id,
      cycle_id: selectCycle.value,
    }).then(res => {
      setSpecialite(res.data.Specialite)
    })
  }
  const addFile = e => {
    var file = e.target.files[0]
    setFile(file)
  }
  const uploadFile = async () => {
    let data = new FormData()
    data.append("file", file)
    data.append("cycle_id", selectCycle.value)
    data.append("niveau_id", selectNiveau.value)
    data.append("departement_id", selectDepartement.value)
    data.append("specialite_id", selectSpecialite.value)
    data.append("annee_id", annee_id)
    const options = {
      onUploadProgress: progressEvent => {
        const { loaded, total } = progressEvent
        let percent = Math.round((loaded * 100) / total)
        console.log(`${loaded}kb of ${total}kb | ${percent}%`)
        if (percent < 100) {
          setUploadPercent(percent)
        }
      },
    }
    API.post("admissions/import", data, options).then(res => {
      setUploadPercent(100)
      API.post("admissions/list", {
        annee_id: annee_id,
      }).then(res => {
        setModal(!modal)
        setOrders(res.data.data)
      })
    })
  }
  const search = async () => {
    const specialite_id = selectSpecialite != "" && selectSpecialite != null  ? selectSpecialite.value: 0
    const niveau_id =  selectNiveau != "" && selectNiveau != null ? selectNiveau.value : 0
    setOrders([])
    const res = await API.post("admissions/list", {
      specialite_id: specialite_id,
      niveau_id: niveau_id,
      session_id: 0,
      annee_id,
    }).then(res => {
      setOrders(res.data.data)
    })
  }
  const searchAll = async () => {
    setSelectCycle("")
    setSelectNiveau("")
    setSelectDepartement("")
    setSelectSpecialite("")
    const res = await API.post("admissions/list", {
      specialite_id: 0,
      niveau_id: 0,
      session_id: 0,
      annee_id,
    }).then(res => {
      setOrders(res.data.data)
    })
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <CardTitle style={{ color: "#556ee6" }} className="h4">
              Critéres de Recherches
            </CardTitle>
            <Form className="mt-4">
              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label>Cycle :</Label>
                    <Select
                      options={cycle}
                      isSearchable
                      value={selectCycle}
                      onChange={e => getNiveau(e)}
                    />
                  </div>
                </Col>

                <Col lg="6">
                  <div className="mb-3">
                    <Label>Niveau :</Label>
                    <Select
                      options={niveau}
                      isSearchable
                      value={selectNiveau}
                      onChange={e => setSelectNiveau(e)}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label>Département :</Label>
                    <Select
                      options={departement}
                      isSearchable
                      value={selectDepartement}
                      onChange={e => getSpec(e)}
                    />
                  </div>
                </Col>

                <Col lg="6">
                  <div className="mb-3">
                    <Label>Spécialité :</Label>
                    <Select
                      options={specialite}
                      isSearchable
                      value={selectSpecialite}
                      onChange={e => setSelectSpecialite(e)}
                    />
                  </div>
                </Col>
              </Row>
            </Form>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Col lg="12">
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-success mb-2 me-2"
                    style={{
                      backgroundColor: "#761C19",
                      borderColor: "#761C19",
                    }}
                    onClick={search}
                  >
                    Rechercher
                  </button>
                  <button
                    type="button"
                    className="btn btn-success mb-2 me-2"
                    style={{
                      backgroundColor: "#761C19",
                      borderColor: "#761C19",
                    }}
                    onClick={searchAll}
                  >
                    Afficher tout
                  </button>
                  {excel === 1 ? (
                    <button
                      type="button"
                      style={{
                        backgroundColor: "#999f15",
                        borderColor: "#999f15",
                      }}
                      className="btn btn-success mb-2 me-2"
                      onClick={toggle}
                    >
                      {"Importer la liste des étudiants"}
                    </button>
                  ) : null}
                </div>
              </Col>
            </div>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    {/*{Columns().length > 0 && (*/}
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                    {/*)}*/}
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement en cours...")}
            </h4>
          </div>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "20px",
            color: "#556ee6",
          }}
          toggle={toggle}
        >
          Importation Liste Etudiants
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            {uploadPercent <= 0 ? (
              <Input
                onChange={e => addFile(e)}
                className="form-control mt-4"
                type="file"
                id="formFile"
              />
            ) : null}
            {uploadPercent > 0 && uploadPercent < 100 ? (
              <Progress
                striped
                className="progress-xl"
                color="success"
                value={uploadPercent}
              >
                {uploadPercent}%
              </Progress>
            ) : null}
            {uploadPercent == 100 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                Success
                <i
                  style={{
                    paddingLeft: "5px",
                    color: "darkcyan",
                    paddingTop: "3.5px",
                  }}
                  className="fas fa-check me-1"
                />
              </div>
            ) : null}
            {uploadPercent != 100 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="button"
                  color="success"
                  className="btn mb-2 me-2 mt-4"
                  onClick={uploadFile}
                >
                  <i className="fas fa-cloud-upload-alt me-1" />
                  Upload
                </Button>
              </div>
            ) : null}
          </div>
        </ModalBody>
      </Modal>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableImportListeEtudiantOrientation))
DataTableImportListeEtudiantOrientation.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
